module.exports = "<div class=\"container\">\n  <div class=\"ctrl-panel\">\n    <h3>{{ssShowCtrl.saver.title}}</h3>\n    <p>型号：{{ssShowCtrl.saver.model}}</p>\n  </div>\n\n  <div class=\"\">\n    <div class=\"row\">\n      <div class=\"col-sm-4 col-md-3\" ng-repeat=\"img in ssShowCtrl.saver.files\">\n        <div class=\"thumbnail\">\n          <img src=\"{{img.url}}\" alt=\"...\">\n          <div class=\"caption\">\n            <h3>{{img.originalname}}</h3>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/screenSaver/show/show.html
// module id = 429
// module chunks = 0